<template>
  <main>
    <contact-us-blurb />
    <div class="container-fluid bg-white pt-3">
      <div class="container">
        <food-navbar current="recipe-maker" />
      </div>
    </div>
    <div class="container-fluid bg-white pt-5">
      <div class="container">
        <div class="page-title-box">
          Recipe Maker <i
            v-tooltip:top="'Have a recipe that contains multiple ingredients? Enter it here to get it’s FFF color and factor!'"
            class="text-primary fa fa-info-circle"
          />
        </div>
      </div>
    </div>
    <div class="container-fluid bg-white py-5">
      <div class="container">
        <div class="page-sidebar-layout">
          <form
            class="side main recipe-maker-form"
            @submit.prevent="save_recipe"
          >
            <div class="field">
              <h4 v-if="edit_recipe_id==''">
                Recipe Details
              </h4>
              <h4 v-else>
                Edit Recipe Details - <a href="">Create New Recipe</a>
              </h4>
            </div>

            <DangerAlert :errors="errors" />

            <div class="field horizontal">
              <div
                class="label"
                style="flex: none; width: auto;"
              >
                <label
                  v-if="edit_recipe_id==''"
                  for="recipe_name"
                >Name your recipe:</label>
                <label
                  v-else
                  for="recipe_name"
                >Recipe Name:</label>
              </div>
              <div class="input">
                <input
                  id="recipe_name"
                  ref="recipe_name"
                  v-model="meal_log_data.name"
                  class="fff-ui"
                  name="recipe_name"
                  placeholder="Enter a Name"
                  type="text"
                >
              </div>
            </div>

            <div class="field">
              <textarea
                v-model="meal_log_data.directions"
                class="fff-ui"
                placeholder="Recipe Directions (if you think its needed)"
              />
            </div>

            <div class="field">
              <h4 v-if="edit_recipe_id==''">
                Ingredients
              </h4>
              <h4 v-else>
                Edit Ingredients
              </h4>
            </div>

            <div class="field ingredients">
              <div
                v-for="(ingredient, ii) in meal_log_data.ingredients"
                class="ingredient"
              >
                <div class="split">
                  <!-- <div class="side drag">
										<i class="fas fa-bars"></i>
									</div> -->
                  <div class="side flex">
                    <input
                      ref="ingredient_name_input"
                      v-model="ingredient.name"
                      autocomplete="off"
                      class="fff-ui"
                      name="ingredient_name"
                      placeholder="Ingredient Name"
                      type="text"
                      @keyup="getItems(ii,ingredient.name);"
                    >
                    <div
                      v-show="ingredient.itemresults_showing"
                      class="results"
                    >
                      <div
                        v-for="(result, index) in ingredient.itemresults"
                        :key="index"
                        class="result"
                        @click="select_result(ii,result)"
                      >
                        <div class="icon">
                          &gt;
                        </div>
                        <div
                          :title="result.name"
                          class="info"
                        >
                          {{ result.name }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="side flex">
                    <fraction-to-decimal-input
                      v-model="ingredient.serving_size"
                      class="fff-ui"
                      min="0"
                      name="ingredient_size"
                      placeholder="Serving Size"
                      size="3"
                      step="0.01"
                    />
                  </div>
                  <div class="side flex">
                    <div class="select-container">
                      <select
                        v-model="ingredient.serving_unit"
                        class="fff-ui"
                      >
                        <option value="">
                          Choose a Unit
                        </option>
                        <option value="teaspoon">
                          {{ friendly_units['teaspoon'] }}
                        </option>
                        <option value="tablespoon">
                          {{ friendly_units['tablespoon'] }}
                        </option>
                        <option value="cp">
                          {{ friendly_units['cp'] }}
                        </option>
                        <option value="pt">
                          {{ friendly_units['pt'] }}
                        </option>
                        <option value="qt">
                          {{ friendly_units['qt'] }}
                        </option>
                        <option value="gal">
                          {{ friendly_units['gal'] }}
                        </option>
                        <option value="floz">
                          {{ friendly_units['floz'] }}
                        </option>
                        <option value="g">
                          {{ friendly_units['g'] }}
                        </option>
                        <option value="lb">
                          {{ friendly_units['lb'] }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="side">
                    <button
                      class="rem button"
                      type="button"
                      @click="remove_ingredient(ii)"
                    >
                      <i
                        class="fas fa-times"
                        style="margin: 0;"
                      />
                    </button>
                  </div>
                </div>
              </div>
              <button
                class="button tertiary fluid addingbtn"
                type="button"
                @click="add_ingredient"
              >
                <i
                  class="fas fa-plus-circle"
                /> Add Ingredient
              </button>
              <div class="row mt-4">
                <div class="col">
                  <label for="recipe_servings">Number of Servings Created by Recipe:</label>
                </div>
                <div class="col">
                  <label for="recipe_servings_measure">Servings measured in:</label>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <input
                    id="recipe_servings"
                    v-model="meal_log_data.number_of_servings"
                    class="fff-ui"
                    min="0"
                    name="recipe_servings"
                    placeholder="1"
                    type="number"
                  >
                </div>
                <div class="col">
                  <div class="select-container">
                    <select
                      id="recipe_servings_measure"
                      v-model="meal_log_data.servings_unit"
                      class="fff-ui"
                    >
                      <option value="">
                        Choose a Unit
                      </option>
                      <option value="teaspoon">
                        {{ friendly_units['teaspoon'] }}
                      </option>
                      <option value="tablespoon">
                        {{ friendly_units['tablespoon'] }}
                      </option>
                      <option value="cp">
                        {{ friendly_units['cp'] }}
                      </option>
                      <option value="pt">
                        {{ friendly_units['pt'] }}
                      </option>
                      <option value="qt">
                        {{ friendly_units['qt'] }}
                      </option>
                      <option value="gal">
                        {{ friendly_units['gal'] }}
                      </option>
                      <option value="floz">
                        {{ friendly_units['floz'] }}
                      </option>
                      <option value="g">
                        {{ friendly_units['g'] }}
                      </option>
                      <option value="lb">
                        {{ friendly_units['lb'] }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <DangerAlert :errors="errors" />
              <div class="actions">
                <button
                  class="button large savebtn"
                  type="button primary"
                >
                  {{ (edit_recipe_id == '' ? 'Save Recipe' : 'Save Recipe Changes') }}
                </button>
              </div>
            </div>

            <div
              v-if="edit_recipe_id!=''"
              class="field"
            >
              <h4>Summary</h4>
            </div>

            <div
              v-if="edit_recipe_id!=''"
              class="field recipe-summary"
            >
              <div class="split">
                <div class="side factor">
                  <div
                    class="food-factor-circle"
                    :class="[meal_log_data.food_color.toLowerCase()]"
                  >
                    <auto-fit-text>{{ meal_log_data.food_factor }}</auto-fit-text>
                  </div>
                </div>
                <div class="side info">
                  Total Servings: {{ meal_log_data.number_of_servings }}<br>
                  Single Serving: {{ meal_log_data.display_single }} {{
                    meal_log_data.display_unit
                  }}<br>
                  Recipe Makes: {{ meal_log_data.display_total }} {{ meal_log_data.display_unit }}<br>
                  <span v-if="meal_log_data.allergens.length > 0">Allergens: {{
                    meal_log_data.allergens.join(', ')
                  }}<br></span>
                  <span v-if="meal_log_data.food_groups.length > 0">Food Groups: {{
                    meal_log_data.food_groups.join(', ')
                  }}</span>
                </div>
                <div class="side actions">
                  <button
                    class="button"
                    type="button"
                    @click="updatemodalData(meal_log_data); is_showing_add_meal_modal = true; "
                  >
                    Add to Meal Log
                  </button>
                </div>
              </div>
            </div>
          </form>

          <div class="side sidebar">
            <div class="sidebar-card">
              <h2>My Recipes</h2>
              <div class="container">
                <input
                  v-model="recipe_search"
                  class="fff-ui fluid"
                  placeholder="Search..."
                  type="text"
                >
              </div>
              <div class="action-list">
                <div
                  v-for="(recipe, recipe_index) in recipes"
                  class="item"
                >
                  <div class="split">
                    <div
                      class="title"
                      @click="show_recipe_details_modal(recipe_index)"
                    >
                      {{ recipe.name }}
                    </div>
                    <div class="actions">
                      <button
                        class="button small"
                        type="button secondary"
                        @click="updatemodalData(recipe); is_showing_add_meal_modal = true; "
                      >
                        Add Meal
                      </button>
                    </div>
                  </div>
                </div>
                <div
                  v-show="recipes_has_more_pages"
                  class="item"
                >
                  <button
                    class="button small secondary"
                    type="button"
                    @click="load_more_recipes"
                  >
                    Load more...
                  </button>
                </div>
              </div>
              <div class="action-list">
                <router-link
                  :to="{name: 'fff-recipes'}"
                  class="button fluid"
                >
                  FFF Recipes
                </router-link>
                <router-link
                  :to="{name: 'my-recipes'}"
                  class="button fluid"
                  style="margin-top: 10px;"
                >
                  My Recipes
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Add Meal Modal -->
    <add-meal-modal
      v-show="is_showing_add_meal_modal"
      :iteminfo="modalData"
      @hide-modal="is_showing_add_meal_modal = false"
      @meal-log-entry-added="recipe_search = ''"
    />

    <!-- Upgrade Modal -->
    <upgrade-modal
      v-show="is_showing_upgrade_modal"
      @show-modal="is_showing_upgrade_modal = true"
      @hide-modal="is_showing_upgrade_modal = false"
    />

    <!-- Recipe Modal -->
    <recipe-details-modal
      v-if="modal_recipe"
      v-show="is_showing_recipe_details_modal"
      :recipe="modal_recipe"
      @close="hide_recipe_details_modal"
      @toggle-favorite="toggle_favorite"
    >
      <template #actions>
        <button
          class="button"
          @click="updatemodalData(modal_recipe); is_showing_add_meal_modal = true; is_showing_recipe_details_modal = false;"
        >
          Add to Meal Log
        </button>
        <button
          class="button tertiary"
          @click="showedit(modal_recipe)"
        >
          Edit
        </button>
        <button
          class="button tertiary"
          @click="deleterecipe(modal_recipe)"
        >
          Delete
        </button>
      </template>
    </recipe-details-modal>
  </main>
</template>

<script>
import foodcleaner from '../components/FoodSearchShared'
import foodcalc from '../components/FoodCalculator'
import FractionToDecimalInput from "../components/FractionToDecimalInput";
import DangerAlert from "../components/DangerAlert";
import RecipeDetailsModal from "../components/RecipeDetailsModal";
import Vue from "vue";
import { debounce } from 'lodash';
import utils from "../utils";
import {FRIENDLY_UNITS} from "../recipe_maker_vars";

export default {
  name: 'RecipeMaker',
  components: {
    FractionToDecimalInput,
    DangerAlert,
    RecipeDetailsModal,
  },
  data() {
    return {
      recipes: [],
      meal_log_data: {
        name: '',
        directions: '',
        number_of_servings: 1,
        servings_unit: 'cp',
        ingredients: [
          {
            name: '',
            sid: '',
            serving_size: '',
            serving_unit: '',
            color: '',
            itemresults_showing: false,
            itemresults: []
          },
        ],
      },
      friendly_units: FRIENDLY_UNITS,
      is_showing_add_meal_modal: false,
      is_showing_recipe_details_modal: false,
      is_showing_upgrade_modal: false,
      modal_recipe: false,
      modalData: {},
      currentspiral: '',
      recipe_search: '',
      edit_recipe_id: '',
      errors: {},
      recipe_pages: 1,
      recipes_has_more_pages: true,
      debounced_load_recipes: null,
      foodItemsWithCategories: [],					// For mapping food item sid to food categories
    };
  },
  watch: {
    is_showing_add_meal_modal: function () {
      if (this.$parent.user.type != 'individual') {
        this.is_showing_upgrade_modal = true;
        this.is_showing_add_meal_modal = false;
      }
    },
    recipe_search: function () {
      // Reset the number of pages shown on each search.
      this.recipe_pages = 1;

      this.debounced_load_recipes();
    }
  },
  async mounted() {
    this.loadrecipes();

    this.loadFoodItemsWithCategories();

    this.debounced_load_recipes = debounce(this.loadrecipes, 500);

    this.$nextTick(() => {
      this.$refs.recipe_name.focus();
    });
  },
  methods: {
    unit_conversion(x) {
      return foodcalc.unit_conversion[x];
    },
    displayconvert(x) {
      return foodcalc.displayconvert[x];
    },
    add_ingredient() {
      this.meal_log_data.ingredients.push({
        name: '',
        serving_size: '',
        serving_unit: '',
        sid: '',
        itemresults_showing: false,
        itemresults: []
      });

      this.$nextTick(() => {
        this.$refs['ingredient_name_input'][this.$refs['ingredient_name_input'].length - 1].focus();
      });
    },
    remove_ingredient(i) {
      if (i > -1) {
        this.meal_log_data.ingredients.splice(i, 1);
      }
    },
    show_recipe_details_modal(recipe_index) {
      var obj_multi = document.querySelectorAll('.container');
      for (const key in obj_multi) {
        if (obj_multi.hasOwnProperty.call(obj_multi, key)) {
          const ele = obj_multi[key];
          if (ele.querySelectorAll('.fff-modal').length === 0) {
            ele.classList.add('dialog-no-print');
          }
        }
      }
      var obj_multi = document.querySelectorAll('.container-fluid');
      for (const key in obj_multi) {
        if (obj_multi.hasOwnProperty.call(obj_multi, key)) {
          const ele = obj_multi[key];
          if (ele.querySelectorAll('.fff-modal').length === 0) {
            ele.classList.add('dialog-no-print');
          }
        }
      }
      this.is_showing_recipe_details_modal = true;
      if (isNaN(recipe_index)) {
        this.modal_recipe = recipe_index;
      } else {
        this.modal_recipe = this.recipes[recipe_index];
      }
    },
    hide_recipe_details_modal() {
      var obj_multi = document.querySelectorAll('.dialog-no-print');
      for (const key in obj_multi) {
        if (obj_multi.hasOwnProperty.call(obj_multi, key)) {
          const ele = obj_multi[key];
          ele.classList.remove('dialog-no-print');
        }
      }
      this.is_showing_recipe_details_modal = false;
    },
    async toggle_favorite(modal_recipe) {
      // API request here
      if (this.$parent.user.type == 'individual') {

        let updateditem = await this.$http('/api/recipe/favorites', {
          method: "post",
          body: JSON.stringify({
            'food_recipe_id': modal_recipe.id
          }),
        }).then(response => response.json())
          .then(async function (json) {
            return json.data;
          });

        modal_recipe.is_favorited = !modal_recipe.is_favorited;
      } else {
        this.is_showing_upgrade_modal = true;
      }

    },
    async getItems(ii, term) {
      if (term != '' && term.length < 3) {
        return;
      }
      console.log(this.meal_log_data.ingredients[ii]);
      let fooddata = await foodcleaner.search(term, 0, {
        'onlyIngredients': 1,
        'perpage': 1000,
      });
      this.currentspiral = fooddata.meta.spiral;
      let foodItems = await foodcleaner.cleanfooditems(fooddata.data);
      this.meal_log_data.ingredients[ii].itemresults = [];
      for (let i = 0; i < foodItems.length; i++) {
        this.meal_log_data.ingredients[ii].itemresults.push({
          'name': foodItems[i].name.toLowerCase(),
          'sid': foodItems[i].food_items_sid,
          'rm_serving_size': foodItems[i].rm_serving_size,
          'serving_size': foodItems[i].serving_amount,
          'serving_unit': foodItems[i].serving_unit,
          'cal_serving': foodItems[i].cal_serving,
          'carb_serving': foodItems[i].carb_serving,
          'fiber_serving': foodItems[i].fiber_serving,
          'na_serving': foodItems[i].na_serving,
          'k_serving': foodItems[i].k_serving,
          'p_serving': foodItems[i].p_serving,
          'fluids': foodItems[i].fluids,
          'fat_serving': foodItems[i].fat_serving,
          'color': foodItems[i].color,
          'factor': foodItems[i].factor
        });
      }
      this.meal_log_data.ingredients[ii].itemresults_showing = true;
    },
    select_result(ii, item) {
      this.meal_log_data.ingredients[ii].name = item.name;
      this.meal_log_data.ingredients[ii].sid = item.sid;
      this.meal_log_data.ingredients[ii].serving_size = '__OVERRIDE__' + item.serving_size;
      this.meal_log_data.ingredients[ii].serving_unit = item.serving_unit;
      this.meal_log_data.ingredients[ii].cal_serving = item.cal_serving;
      this.meal_log_data.ingredients[ii].carb_serving = item.carb_serving;
      this.meal_log_data.ingredients[ii].fiber_serving = item.fiber_serving;
      this.meal_log_data.ingredients[ii].na_serving = item.na_serving;
      this.meal_log_data.ingredients[ii].k_serving = item.k_serving;
      this.meal_log_data.ingredients[ii].p_serving = item.p_serving;
      this.meal_log_data.ingredients[ii].fluids = item.fluids;
      this.meal_log_data.ingredients[ii].fat_serving = item.fat_serving;
      this.meal_log_data.ingredients[ii].rm_serving_size = item.rm_serving_size;
      this.meal_log_data.ingredients[ii].color = item.color;
      this.meal_log_data.ingredients[ii].factor = item.factor;
      this.meal_log_data.ingredients[ii].itemresults_showing = false;
      this.meal_log_data.ingredients[ii].itemresults = [];
    },
    async save_recipe() {
      if (this.$parent.user.type == 'individual') {
        //console.log("meal log data:")
        //console.log(this.meal_log_data);
        let items = this.meal_log_data.ingredients;
        // console.log('[save_recipe] items: ', items);		// Debug only
        let selecteditems = [];
        for (let i = 0; i < items.length; i++) {
          let sid = items[i].sid ? items[i].sid : items[i].food_items_sid;

          if (sid === '' || sid === undefined) {
            this.errors = {
              food_items: [
                'The ingredient "' + items[i].name + '" could not be found. Please select an option from the search results.'
              ]
            };

            return;
          }

          selecteditems[i] = {};
          selecteditems[i].sid = sid;
          selecteditems[i].name = items[i].name;
          selecteditems[i].serving_size = parseFloat(items[i].serving_size); /*amount entered by user*/
          selecteditems[i].serving_unit = items[i].serving_unit; /*selected unit from dropdown*/
          selecteditems[i].cal_serving = parseFloat(items[i].cal_serving); /*calories per serving*/
          selecteditems[i].carb_serving = parseFloat(items[i].carb_serving); /*carbs per serving - ccfs spiral */
          selecteditems[i].fiber_serving = parseFloat(items[i].fiber_serving); /*fiber per serving - hfs and dfs spiral */
          selecteditems[i].na_serving = parseFloat(items[i].na_serving); /*sodium per serving - lsfs and rfs and rdfs spiral */
          selecteditems[i].k_serving = parseFloat(items[i].k_serving); /*potassium per serving - rfs and rdfs spiral */
          selecteditems[i].p_serving = parseFloat(items[i].p_serving); /*phosphates per serving - rfs and rdfs spiral */
          selecteditems[i].fluids = parseFloat(items[i].fluids); /*fluids per serving - rfs and rdfs spiral */
          selecteditems[i].fat_serving = parseFloat(items[i].fat_serving); /*fats per serving - rdfs spiral */
          selecteditems[i].rm_serving_size = parseFloat(items[i].rm_serving_size); /*serving size in grams*/
          selecteditems[i].color = items[i].color.toUpperCase();
          selecteditems[i].factor = items[i].factor;
          selecteditems[i].categories = this.mapFoodItemSidToFoodCategories(selecteditems[i].sid);

          let itemunitval = 0;
          await Object.keys(foodcalc.unit_conversion).map(function (key, index) {
            if (key = items[i].serving_unit) { /*find matching unit conversion to grams*/
              // console.log("1. - " + foodcalc.unit_conversion[key]);
              itemunitval = parseFloat(foodcalc.unit_conversion[key]); /*set unit grams value*/
            }
          });

          if (itemunitval == 0 && items[i].serving_unit == 'g') {
            // console.log("2. - " + items[i].rm_serving_size);
            itemunitval = parseFloat(items[i].rm_serving_size); /*for type grams use the value directly*/
          }
          //console.log("itemunitval");
          //console.log(itemunitval);
          selecteditems[i].rec_quantity_rm = parseFloat(items[i].serving_size * itemunitval); /*quantity times the unit in grams*/
        }
        // console.log("converted fooditems to selecteditems:");
        // console.log(selecteditems);
        // console.log("servings:" + this.meal_log_data.number_of_servings);

        let calcs = await this.calculate_recipe_values(selecteditems, this.meal_log_data.number_of_servings);
        // console.log("calcs results:");
        // console.log(calcs);

        this.errors = {};

        let data;

        if (this.edit_recipe_id == '') {

          let response = await this.$http('/api/recipe/myrecipes', {
            method: "post",
            body: JSON.stringify({
              'name': this.meal_log_data.name,
              'directions': this.meal_log_data.directions,
              'servings': this.meal_log_data.number_of_servings,
              'servings_unit': this.meal_log_data.servings_unit,
              'ingredients': selecteditems,
              'rm_factor': (parseFloat(calcs.rm_factor) > 0.00 ? calcs.rm_factor : '0'),
              'rm_color': calcs.rm_color,
              'rm_total_servings_g': calcs.rm_total_servings_g,
              'rm_individual_serving_g': calcs.rm_individual_serving_g,
              'rm_json': calcs
            }),
          }).then(response => response.json())
            .then((json) => {
              return json;
            }).catch(error => {
              return {
                "errors": [error.toString()]
              };
            });

          if (!response.data) {
            this.errors = response.errors;
            return;
          }

          let recipedata = response.data[0];

          // console.log("new recipe data:");
          // console.log(recipedata);
          data = await this.process_recipes_for_display([recipedata]);
          // console.log('data');
          // console.log(data);
          this.recipes.push(data[0]);

        } else {
          let response = await this.$http('/api/recipe/myrecipes/' + this.edit_recipe_id, {
            method: "put",
            body: JSON.stringify({
              'name': this.meal_log_data.name,
              'directions': this.meal_log_data.directions,
              'servings': this.meal_log_data.number_of_servings,
              'servings_unit': this.meal_log_data.servings_unit,
              'ingredients': selecteditems,
              'rm_factor': calcs.rm_factor,
              'rm_color': calcs.rm_color,
              'rm_total_servings_g': calcs.rm_total_servings_g,
              'rm_individual_serving_g': calcs.rm_individual_serving_g,
              'rm_json': calcs
            }),
          }).then(response => response.json())
            .then(function (json) {
              return json;
            }).catch(error => {
              return {
                "errors": [error.toString()]
              };
            });

          if (!response.data) {
            this.errors = response.errors;
            return;
          }

          let recipedata = response.data[0];

          // console.log("edit recipe data:");
          // console.log(recipedata);
          // console.log(JSON.parse(JSON.stringify(recipedata)));
          data = await this.process_recipes_for_display([recipedata]);
          // console.log('data');
          // console.log(JSON.parse(JSON.stringify(data)));
          // console.log(data);
          this.edit_recipe_id = '';
          // this.show_recipe_details_modal(data[0]);
        }
        this.meal_log_data = { /*is there a better way to reset it? */
          name: '',
          directions: '',
          number_of_servings: 1,
          servings_unit: '',
          ingredients: [
            {
              name: '',
              sid: '',
              serving_size: 1,
              serving_unit: '',
              color: '',
              itemresults_showing: false,
              itemresults: []
            },
          ],
        };

        // alert('Awesome, your recipe has been saved!');
        // this.showedit(data[0].id);
        this.show_recipe_details_modal(data[0]);

        // this.is_showing_recipe_details_modal = true;
        // this.modal_recipe = data[0];

        // this.$router.go();
        this.loadrecipes();
      } else {
        this.is_showing_upgrade_modal = true;
      }

    },
    async calculate_recipe_values(fooditems, servings) {
      let calcs = [];
      const spiral = this.currentspiral;
      console.log("Spiral:" + spiral);
      let recipe_data = {
        "servings": servings,
        "ingredients": fooditems
      }
      console.log('data passed to conversion function:');
      console.log(recipe_data);

      recipe_data = foodcalc.preprocess_zero_factor_ingredients(recipe_data, spiral);

      if (spiral == 'ccfs') { //check
        calcs = await foodcalc.calculate_recipe_ccfs(recipe_data);
        console.log("calcs ccfs", calcs);
        calcs.rm_factor = calcs.factor_recipe;
        calcs.rm_color = calcs.color_recipe;
        calcs.rm_total_servings_g = calcs.sum_rec_quantity_rm;
        calcs.rm_individual_serving_g = calcs.individual_serving_size;
      }
      if (spiral == 'hfs') {//check
        calcs = await foodcalc.calculate_recipe_hfs(recipe_data);
        console.log("calcs hfs", calcs);
        calcs.rm_factor = calcs.sum_factor_individual;
        calcs.rm_color = calcs.color_recipe;
        calcs.rm_total_servings_g = calcs.sum_rec_quantity_rm;
        calcs.rm_individual_serving_g = calcs.individual_serving_size;
      }
      if (spiral == 'dfs') {//check
        calcs = await foodcalc.calculate_recipe_dfs(recipe_data);
        console.log("calcs dfs", calcs);
        calcs.rm_factor = calcs.factor_recipe;
        calcs.rm_color = calcs.color_recipe;
        calcs.rm_total_servings_g = calcs.sum_rec_quantity_rm;
        calcs.rm_individual_serving_g = calcs.individual_serving_size;
      }
      if (spiral == 'rfs') {//check
        calcs = await foodcalc.calculate_recipe_rfs(recipe_data);
        console.log("calcs rfs", calcs);
        calcs.rm_factor = calcs.factor_recipe;
        calcs.rm_color = calcs.color_recipe;
        calcs.rm_total_servings_g = calcs.sum_rec_quantity_rm;
        calcs.rm_individual_serving_g = calcs.individual_serving_size;
      }
      if (spiral == 'rdfs') {//check
        const rfs_data = await foodcalc.calculate_recipe_rfs(recipe_data);
        rfs_data.rm_factor = rfs_data.factor_recipe;
        rfs_data.rm_color = rfs_data.color_recipe;
        rfs_data.rm_total_servings_g = rfs_data.sum_rec_quantity_rm;
        rfs_data.rm_individual_serving_g = rfs_data.individual_serving_size;

        const dfs_data = await foodcalc.calculate_recipe_dfs(recipe_data);
        dfs_data.rm_factor = dfs_data.factor_recipe;
        dfs_data.rm_color = dfs_data.color_recipe;
        dfs_data.rm_total_servings_g = dfs_data.sum_rec_quantity_rm;
        dfs_data.rm_individual_serving_g = dfs_data.individual_serving_size;

        calcs = await foodcalc.calculate_recipe_rdfs(recipe_data, rfs_data, dfs_data);
        console.log("calcs rdfs", calcs);
        calcs.rm_factor = calcs.factor_recipe;
        calcs.rm_color = calcs.color_recipe;
        calcs.rm_total_servings_g = calcs.sum_rec_quantity_rm;
        calcs.rm_individual_serving_g = calcs.individual_serving_size;
      }
      if (spiral == 'lsfs') {//check
        calcs = await foodcalc.calculate_recipe_lsfs(recipe_data);
        console.log("calcs lsfs", calcs);
        calcs.rm_factor = calcs.factor_recipe;
        calcs.rm_color = calcs.color_recipe;
        calcs.rm_total_servings_g = calcs.sum_rec_quantity_rm;
        calcs.rm_individual_serving_g = calcs.individual_serving_size;
      }

      return calcs;
    },
    process_recipes_for_display(recipedata) {
      return foodcleaner.process_recipes_for_display(recipedata);
    },
    updatemodalData(recipeinfo) {
      this.modalData['type'] = 'recipe';
      this.modalData['serving_size'] = recipeinfo.single_serving.toFixed(2);
      this.modalData['serving_unit'] = recipeinfo.servings_unit;
      this.modalData['food_recipe_id'] = recipeinfo.id;
      this.modalData['meal_name'] = recipeinfo.name;		// To change title in modal
      this.modalData = Object.assign({}, this.modalData, this.modalData);
      // console.log('[updatemodalData] recipeinfo', recipeinfo);				// Debug only
      // console.log("[updatemodalData] modaldata", this.modalData);		// Debug only
    },
    showedit(recipe) {
      // Duplicate the recipe so the next step doesn't mess it up
      let newRecipe = Object.assign({}, recipe);

      // Clear any previous ingredients and wait until the next
      // DOM update cycle so that the FractionToDecimal components
      // are deleted and re-mounted, causing their values to update.
      this.meal_log_data.ingredients = [];

      Vue.nextTick(() => {
        this.meal_log_data = newRecipe;
        this.edit_recipe_id = newRecipe.id;
        this.is_showing_recipe_details_modal = false;
        this.currentspiral = newRecipe.spiral_name;
      });
    },
    async deleterecipe(recipe) {
      if (confirm("Are you sure you want to delete this recipe?")) {
        let delrec = await this.$http('/api/recipe/myrecipes/' + recipe.id, {
          method: "delete",
        }).then(response => response.json())
          .then(async function (json) {
            alert("The recipe has been deleted");
            return json;
          });
        this.loadrecipes();
        this.is_showing_recipe_details_modal = false;

      }
    },
    async loadrecipes() {
      let params = new URLSearchParams();
      params.append('recipe_type', 'mine_no_fff');

      if (typeof this.recipe_search == 'string' && this.recipe_search !== '') {
        params.append('q', this.recipe_search);
      }

      let getrecipes = [];

      for (let page = 1; page <= this.recipe_pages; page++) {
        params.set('page', page);

        let response = await this.$http('/api/recipe/myrecipes?' + params.toString(), {
          method: "get",
        }).then(response => response.json())
          .then(async function (json) {
            return json;
          });

        getrecipes.push(...response.data);

        if (response.meta.current_page >= response.meta.last_page) {
          this.recipes_has_more_pages = false;
          break;
        } else {
          this.recipes_has_more_pages = true;
        }
      }

      if (typeof (getrecipes) != 'undefined' && getrecipes.length > 0) {
        let recipedata = await this.process_recipes_for_display(getrecipes);
        // console.log("recipedata");
        // console.log(recipedata);
        this.recipes = recipedata;
      }
    },
    load_more_recipes() {
      this.recipe_pages++;

      this.loadrecipes();
    },
    async loadFoodItemsWithCategories() {
      const url = '/api/fooditems/allWithCategories';
      const fetchOptions = {
        method: "get",
      };
      const response = await this.$http(url, fetchOptions);
      const data = await response.json();
      this.foodItemsWithCategories = data.foodItems;
      // console.log('[loadFoodItemsWithCategories] data: ', data);		// Debug only
    },
    mapFoodItemSidToFoodCategories(foodItemSid) {
      return this.foodItemsWithCategories
        .filter((foodItem) => {
          return foodItem.food_items_sid == foodItemSid;
        })
        .map((foodItem) => {
          return {
            category: foodItem.name,
            categorySid: foodItem.food_category_sid,
          }
        });
    }
  },
};
</script>

<style lang="scss" scoped>
.ingredient .side.flex {
	position: relative;
}

.ingredient .results {
	width: 326%;
	max-height: 336px;
	position: absolute;
	top: 100%;
	right: 0;
	left: 0;
	background: #fff;
	box-shadow: 0 0 24px rgba(0, 0, 0, 0.2);
	border-radius: 6px;
	overflow: auto;
	padding-bottom: 8px;
	z-index: 1;
}

.ingredient .results .title {
	background: #f0f0f0;
	padding: 8px 12px;
	color: #888;
	text-transform: uppercase;
	font-weight: 700;
	font-size: 12px;
}

.ingredient .results .result {
	display: flex;
	justify-content: flex-start;
	align-items: flex-start;
	flex-wrap: wrap;
	font-size: 16px;
	padding: 12px 12px 12px 0;
	font-weight: 700;
	cursor: pointer;
}

.ingredient .results .result:hover {
	background: #f0f0f0;
}

.ingredient .results .icon {
	width: 40px;
	display: inline-block;
	text-align: center;
	color: #5f9f3b;
}

.ingredient .results .info {
	flex: 1;
	min-width: 0;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	text-transform: capitalize;
}

.recipeinputs {
	display: flex;
	flex-wrap: wrap;
	justify-content: space-between;
}

.recipeinputs .side {
	width: 50%;
}

.space {
	margin: 20px 0;
}

.addingbtn {
	text-align: right;
}

.savebtn {
	display: block;
	margin: 20px auto;
}
</style>
